'use strict';

angular.module('cgmemApp')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('authenticated.profile', {
        url: '/',
        templateUrl: 'app/profile/profile.html',
        controller: 'ProfileCtrl',
				sp: {
					authenticate: true
				}
      });
  }]);